export default "__VITE_PUBLIC_ASSET__80545e2c__"